import { render, staticRenderFns } from "./PermanentBan.vue?vue&type=template&id=2387756a&scoped=true&"
import script from "./PermanentBan.vue?vue&type=script&lang=ts&"
export * from "./PermanentBan.vue?vue&type=script&lang=ts&"
import style0 from "./PermanentBan.vue?vue&type=style&index=0&id=2387756a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2387756a",
  null
  
)

export default component.exports